import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.tags')
  .factory('$tags', TagsObjectFactory);

/* @ngInject */
function TagsObjectFactory($bringozFactory: $bringozFactory,
                           TagsAPI: BringozApi,
                           Tags_DS: DataStoreConfig) {

  function $tags(id: string) {
    return $bringozFactory(id, TagsAPI, Tags_DS);
  }

  return $tags;
}
